import { Navigate } from "react-router-dom";
import { providerActions } from "../../Store/Provider/reducer";
import { useAppDispatch } from "../../Store/Hooks";
import { signOut } from "aws-amplify/auth";


const Logout = () => {

    const dispatch = useAppDispatch();
    dispatch(providerActions.logout());
    signOut();
    localStorage.clear();

    return (
        <>
            Logging Out
            <Navigate to={"/"}></Navigate>
        </>
    )
}

export default Logout;